import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { PageText } from './page-text';

export const PAGE_TEXT_DEFAULT_OPTIONS = new InjectionToken<any>('PAGE_TEXT_DEFAULT_OPTIONS');
export const PAGE_TEXT_DATA = new InjectionToken<PageText | Observable<PageText>>('PAGE_TEXT_DATA');
export const PAGE_TEXT_EDITOR_CONFIG = new InjectionToken<any>('PAGE_TEXT_EDITOR_CONFIG');